module.exports = __webpack_public_path__ + "static/thanx-dacff04e9fdbecfd6ea68c147b1f9e25.jpg";